<template>
  <v-form ref="formRef" class="rlt-shared-form method-form">
    <div class="method-section">
      <div class="method-section-heading">
        <v-icon size="22" color="primary">mdi-fan-auto</v-icon>
        <span>Ventilatorberechnung</span>
      </div>

      <v-checkbox
        v-model="form.fanCalculation"
        :error-messages="validationErrors?.external_fan_calculation"
        label="Ventilatoren separat berechnen"
        class="mb-1"
      >
        <template #append>
          <v-tooltip v-if="hint.external_fan_calculation" location="bottom" color="surface" content-class="tooltip">
            <template #activator="{ props }">
              <v-icon v-bind="props">mdi-information</v-icon>
            </template>
            <span>{{ hint.external_fan_calculation }}</span>
          </v-tooltip>
        </template>
      </v-checkbox>

      <div class="shared-form-hint text-body-2 text-medium-emphasis">
        Wenn diese Option aktiviert ist, werden die Ventilatorwerte nicht direkt in der RLT-Maßnahme berechnet.
      </div>
    </div>
  </v-form>
</template>


<script setup>
import { ref, computed, onMounted } from 'vue'
import { useBaseForm } from '@/composables/useBaseForm'

/* ---------------- PROPS ---------------- */
const props = defineProps({
  modelValue: { type: Object, default: () => ({}) }, // v-model sharedData
  validationErrors: { type: Object, default: () => ({}) },
  methodValue: { type: String, default: '' }
})

const emit = defineEmits(['update:modelValue'])

/* ---------------- FIELD MAP ---------------- */
const fields = {
  // frontend → backend
  fanCalculation: 'external_fan_calculation'
}

/* ---------------- useBaseForm (shared form) ---------------- */
const {
  form,            // { fanCalculation }
  hint,            // help text dictionary
  fetchHints,
  // exposeFields is the backend field list → parent will use it to scope shared errors
  exposeFields
} = useBaseForm({
  value: computed(() => props.modelValue),
  fields,
  defaults: { fanCalculation: false },
  reference: computed(() => false),     // shared form is neither planned nor reference
  planned:   computed(() => false),
  shared:    computed(() => true),      // IMPORTANT
  otherData: computed(() => ({})),
  sharedData:computed(() => ({})),
  methodValue: computed(() => props.methodValue),
  emit: (e, payload) => emit(e, payload)
})

/* ---------------- VALIDATION EXPOSE ---------------- */
const formRef = ref(null)
function validateForm() {
  return formRef.value?.validate?.()
}

// Expose backend fields for Action.vue's validationErrorsShared mapping
defineExpose({
  validateForm,
  fields: exposeFields.value
})

/* ---------------- INIT ---------------- */
onMounted(() => {
  fetchHints()
})

// convenience for template binding
const validationErrors = computed(() => props.validationErrors)
</script>

<style scoped lang="scss">
.rlt-shared-form {
  width: 100%;
}

.method-section {
  margin-bottom: 0;
  padding: 1rem;
  border-radius: 24px;
  background-color: rgba(var(--v-theme-primary), 0.025);
  border: 1px solid rgba(var(--v-theme-on-surface), 0.07);
}

.method-section-heading {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  margin-bottom: 1rem;
  padding: 0.75rem 0.9rem;
  border-radius: 18px;
  color: rgb(var(--v-theme-primary));
  background-color: rgba(var(--v-theme-primary), 0.055);
  border: 1px solid rgba(var(--v-theme-primary), 0.1);
  font-size: 1rem;
  font-weight: 700;
}

.rlt-shared-form :deep(.v-checkbox) {
  padding: 0.35rem 0.65rem;
  border-radius: 18px;
  background-color: rgba(var(--v-theme-primary), 0.025);
}

.rlt-shared-form :deep(.v-input__append .v-icon) {
  color: rgb(var(--v-theme-primary));
  opacity: 0.85;
}

.shared-form-hint {
  padding-left: 0.65rem;
  line-height: 1.45;
}
</style>